export const RESET = 'EXSBPOSITION_LIST_RESET'
export const SET_ITEMS = 'EXSBPOSITION_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBPOSITION_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBPOSITION_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBPOSITION_LIST_TOGGLE_LOADING'
